/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited transfers this week`)
};

const es_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traspasos ilimitados esta semana`)
};

const de_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte Transfers diese Woche`)
};

const nl_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbeperkte transfers deze week`)
};

const fr_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transferts illimités cette semaine`)
};

const it_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasferimenti illimitati questa settimana`)
};

const pt_br2_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transferências ilimitadas nesta semana`)
};

const pt_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transferências ilimitadas esta semana`)
};

const ja_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今週は移籍無制限`)
};

const zh_f1_myteam_unlimited_chip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本周转会次数不限`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_myteam_unlimited_chip = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_myteam_unlimited_chip(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_myteam_unlimited_chip", locale)
	if (locale === "en") return en_f1_myteam_unlimited_chip(inputs)
	if (locale === "es") return es_f1_myteam_unlimited_chip(inputs)
	if (locale === "de") return de_f1_myteam_unlimited_chip(inputs)
	if (locale === "nl") return nl_f1_myteam_unlimited_chip(inputs)
	if (locale === "fr") return fr_f1_myteam_unlimited_chip(inputs)
	if (locale === "it") return it_f1_myteam_unlimited_chip(inputs)
	if (locale === "pt-BR") return pt_br2_f1_myteam_unlimited_chip(inputs)
	if (locale === "pt") return pt_f1_myteam_unlimited_chip(inputs)
	if (locale === "ja") return ja_f1_myteam_unlimited_chip(inputs)
	return zh_f1_myteam_unlimited_chip(inputs)
};